<template>
<div class="addon-info">

  <h3 class="header">
      {{label}}
      <span class="pull-right" @click='close'>
        <i class="fa fa-times" aria-hidden="true"></i>
      </span>
    </h3>

  <div class="row" v-for='(item, index) in meta' :key="index">

    <div class="col-xs-4 text-right">
      <b>
          {{item.label}}
        </b>
    </div>

    <div class="col-xs-8">
      {{item.value}}
    </div>

  </div>
  <br>

  <div class="img-block">
    <a :href="item.url" class="thumbnail" target="_blank" v-for='(item, index) in attachments' :key="index">
      <img :src="item.url" width="90px">
    </a>
  </div>

</div>
</template>

<script>
export default {
  props: ['meta', 'attachments'],
  data: function () {
    return {
      label: 'Addon'
    }
  },
  methods: {
    close () {
      this.$emit('closeAddon')
    }
  }
}
</script>
<style scoped lang="stylus" src="../styles/_CockpitAddon.styl"/>



// WEBPACK FOOTER //
// src/components/CockpitAddon.vue